import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Button, Ratio } from 'react-bootstrap';

function Resume() {
  return(
    <Container>    
      <Row className="mt-5 m-4 mb-0">
        <Col> 
        <Button className="m-2" href="https://resume.creddle.io/resume/228g5icmwn9" target="_blank">
          <h2>Open my resume in a new window</h2>
          <p>You can view it in a larger window and right click to save it!</p>
        </Button>
        </Col>
       
      </Row>
      <Row style={{ width: 'auto', height: 'auto' }}>
        <Ratio>
          <iframe id="resume" src="https://resume.creddle.io/resume/228g5icmwn9"></iframe>
        </Ratio>
      </Row>
    </Container>
  
    
  )
}


export default Resume;
